/**
 * Composable for URL validation utilities
 */
export const useUrlValidation = () => {
  /**
   * Validates if a URL has proper format
   * @param url - The URL string to validate
   * @returns true if the URL is valid or empty, false otherwise
   */
  const isValidUrl = (url: string): boolean => {
    if (!url) return true; // Allow empty URLs

    // Check if URL contains proper protocol format (://)
    if (!url.includes('://')) {
      return false;
    }

    try {
      const urlObj = new URL(url);
      // Check for valid protocol and that the URL has a valid hostname
      return (urlObj.protocol === 'http:' || urlObj.protocol === 'https:') && urlObj.hostname.length > 0;
    } catch {
      return false;
    }
  };

  /**
   * FormKit validation rule for URL validation
   * @param node - FormKit node object
   * @returns true if the URL is valid, false otherwise
   */
  const isValidUrlRule = (node: any): boolean => {
    return isValidUrl(node.value);
  };

  return {
    isValidUrl,
    isValidUrlRule,
  };
};
